import classnames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';
import moment from 'moment';

import TimeAgo from './time_ago';
import TimestampFormatter from './lib/timestamp_formatter';

/**
 * Renders a time DOM element in 1 of 3 different formats based on age
 * - before current year
 * - between start of year and 7 days ago
 * - between 7 days ago and now
 * Requires one attribute:
 * @attribute timestamp - ISO8601 string
 *
 * Example
 * ```
 *  <RelativeDateTime timestamp={new Date().toISOString()} />
 *```
 */

const RelativeDateTime = createReactClass({
  displayName: 'RelativeDateTime',

  render() {
    if (
      moment()
        .subtract(7, 'days')
        .isBefore(this.props.timestamp)
    ) {
      return <TimeAgo className={classnames(this.props.className)} timestamp={this.props.timestamp} />;
    }
    return <TimeElement className={classnames(this.props.className)} timestamp={this.props.timestamp} />;
  },
});

const TimeElement = createReactClass({
  displayName: 'TimeElement',

  render() {
    let tf = new TimestampFormatter(this.props.timestamp);
    let fullTime = tf.full();
    let shortTime = tf.relative();

    return (
      <time className={classnames(this.props.className)} dateTime={this.props.timestamp} title={fullTime}>
        {shortTime}
      </time>
    );
  },
});

export default RelativeDateTime;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/date/relative_date_time.jsx